export default __webpack_public_path__ + "static/1-e1104154e3080a4cd9baeb983dafad5e.webp";